import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getAccountQueryOptions } from '@/features/account/api/get-account'; // eslint-disable-line import/no-restricted-paths
import { queryClient } from '@/lib/api-clients/query-client';
import { privateV2Api } from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';
import { ErrorMsgs } from '@/types/enums';

const submitRefCode = (refCode: string) => {
  const promise = privateV2Api.post('/v2/referrals/join', {
    refCode,
  });

  toast.promise(promise, {
    loading: 'Submitting referral code...',
    success: `Joined with referral code ${refCode}!`,
    error: (err) => {
      const error = err as keyof typeof ErrorMsgs;
      if (error in ErrorMsgs) {
        return ErrorMsgs[error];
      }
      return 'Failed to join with referral code';
    },
  });

  return promise;
};

export default function useJoinRefCode() {
  return useMutation({
    mutationFn: submitRefCode,
    onSuccess: (_, code) => {
      localStorage.removeItem('ref-code');
      const { address } = useAccountStore.getState();
      queryClient.setQueryData(
        getAccountQueryOptions(address).queryKey,
        (prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            refCode: code,
          };
        },
      );
    },
  });
}
